import React from 'react';
import { Button } from '../../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const ContactCard = ({ contact, momentCount = 0, fromCard = false, hasDuplicates = false, onResolve, onEdit, onDelete, onFollowUp }) => {
  const name = contact.full_name || 'Unnamed contact';
  const subtitle = [contact.job_title, contact.company].filter(Boolean).join(' at ');

  return (
    <div className="bg-white rounded-3xl border border-slate-200/60 shadow-sm p-5 flex flex-col hover:shadow-md transition-all">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-11 h-11 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-lg font-bold text-slate-400 shrink-0">
          {name.charAt(0).toUpperCase()}
        </div>
        <div className="min-w-0">
          <h3 className="font-bold text-lg text-slate-900 tracking-tight truncate">{name}</h3>
          {subtitle && <p className="text-sm font-medium text-slate-500 truncate">{subtitle}</p>}
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        {momentCount > 0 ? (
          <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider bg-emerald-50 text-emerald-700 border border-emerald-100">
            Connection · {momentCount} {momentCount === 1 ? 'moment' : 'moments'}
          </span>
        ) : (
          <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider bg-slate-100 text-slate-600 border border-slate-200/50">
            Contact
          </span>
        )}
        {fromCard && (
          <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider bg-blue-50 text-blue-700 border border-blue-100">
            From card
          </span>
        )}
        {hasDuplicates && (
          <button
            type="button"
            onClick={() => onResolve && onResolve(contact)}
            className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100"
          >
            Possible duplicate
          </button>
        )}
      </div>
      <div className="space-y-2 flex-1 mb-4 text-sm font-medium text-slate-600">
        {contact.email && (
          <div className="flex items-center min-w-0">
            <SafeIcon icon={FiIcons.FiMail} className="mr-2.5 text-slate-400 shrink-0" />
            <span className="truncate">{contact.email}</span>
          </div>
        )}
        {contact.phone && (
          <div className="flex items-center min-w-0">
            <SafeIcon icon={FiIcons.FiPhone} className="mr-2.5 text-slate-400 shrink-0" />
            <span className="truncate">{contact.phone}</span>
          </div>
        )}
        {!contact.email && !contact.phone && (
          <p className="text-slate-400">No email or phone added.</p>
        )}
      </div>
      <div className="flex gap-2 pt-3 border-t border-slate-100">
        <Button variant="secondary" size="sm" className="flex-1" onClick={() => onEdit(contact)}>
          <SafeIcon icon={FiIcons.FiEdit2} className="mr-1.5" /> Edit
        </Button>
        {onFollowUp && (
          <Button variant="secondary" size="sm" title="Add follow-up" onClick={() => onFollowUp(contact)}>
            <SafeIcon icon={FiIcons.FiCalendar} />
          </Button>
        )}
        <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => onDelete(contact)}>
          <SafeIcon icon={FiIcons.FiTrash2} />
        </Button>
      </div>
    </div>
  );
};